let tooltipEl = null
let hideTimer = null
let showTimer = null

function getTooltip() {
  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.style.cssText = `
      position: fixed;
      border-radius: 8px;
      border: 1px solid #E8EAF2;
      box-shadow: 4px 2px 12px 0px #0D0E1733;
      padding: 8px 12px;
      background: #ffffff;
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
      color: #0D0E17;
      z-index: 9999;
      max-width: 600px;
      word-break: break-all;
      white-space: pre-wrap;
      display: none;
      user-select: text;
    `
    tooltipEl.addEventListener('mouseenter', () => {
      clearTimeout(hideTimer)
    })
    tooltipEl.addEventListener('mouseleave', () => {
      tooltipEl.style.display = 'none'
    })
    document.body.appendChild(tooltipEl)
  }
  return tooltipEl
}

export default {
  bind(el) {
    el._ellipsisMouseenter = () => {
      if (el.scrollWidth <= el.clientWidth) return
      clearTimeout(hideTimer)
      clearTimeout(showTimer)
      showTimer = setTimeout(() => {
        const tooltip = getTooltip()
        tooltip.textContent = el.textContent
        tooltip.style.display = 'block'
        const rect = el.getBoundingClientRect()
        tooltip.style.left = rect.left + 'px'
        tooltip.style.top = (rect.bottom + 0) + 'px'
      }, 200)
    }
    el._ellipsisMouseleave = () => {
      clearTimeout(showTimer)
      hideTimer = setTimeout(() => {
        const tooltip = getTooltip()
        tooltip.style.display = 'none'
      }, 100)
    }
    el.addEventListener('mouseenter', el._ellipsisMouseenter)
    el.addEventListener('mouseleave', el._ellipsisMouseleave)
  },
  unbind(el) {
    el.removeEventListener('mouseenter', el._ellipsisMouseenter)
    el.removeEventListener('mouseleave', el._ellipsisMouseleave)
  }
}
